export default [
  {id: 1, codigo: 'ABACAXI', label: 'Abacaxi', showTipo: true},
  {id: 2, codigo: 'ABOBORA', label: 'Abóbora', showTipo: true},
  {id: 3, codigo: 'ALFAFA', label: 'Alfafa', showTipo: true},
  {id: 4, codigo: 'ALGODAO_HERBACEO', label: 'Algodão herbáceo (em caroço)', showTipo: true},
  {id: 5, codigo: 'ALHO', label: 'Alho', showTipo: true},
  {id: 6, codigo: 'AMENDOIM', label: 'Amendoim (em casca)', showTipo: true},
  {id: 7, codigo: 'ARROZ_SEQUEIRO', label: 'Arroz de sequeiro (em casca)', showTipo: true},
  {id: 8, codigo: 'ARROZ_VARZEA', label: 'Arroz de várzea (em casca)', showTipo: true},
  {id: 9, codigo: 'AVEIA', label: 'Aveia', showTipo: true},
  {id: 10, codigo: 'BATATA_DOCE', label: 'Batata doce', showTipo: true},
  {id: 11, codigo: 'BATATA_INGLESA', label: 'Batata inglesa', showTipo: true},
  {id: 12, codigo: 'CEBOLA', label: 'Cebola', showTipo: true},
  {id: 13, codigo: 'CENOURA', label: 'Cenoura', showTipo: true},
  {id: 14, codigo: 'CENTEIO', label: 'Centeio', showTipo: true},
  {id: 15, codigo: 'CEVADA', label: 'Cevada', showTipo: true},
  {id: 16, codigo: 'ERVILHA', label: 'Ervilha', showTipo: true},
  {id: 17, codigo: 'FAVA', label: 'Fava', showTipo: true},
  {id: 18, codigo: 'FEIJAO', label: 'Feijão', showTipo: true},
  {id: 19, codigo: 'FUMO', label: 'Fumo (em folha seca)', showTipo: true},
  {id: 20, codigo: 'GERGELIM', label: 'Gergelim', showTipo: true},
  {id: 21, codigo: 'GIRASSOL', label: 'Girassol (sementes)', showTipo: true},
  {id: 22, codigo: 'INHAME', label: 'Inhame', showTipo: true},
  {id: 23, codigo: 'JUTA', label: 'Juta (fibras)', showTipo: true},
  {id: 24, codigo: 'LINHO', label: 'Linho (fibras)', showTipo: true},
  {id: 25, codigo: 'MALVA_PLANT', label: 'Malva-plantado', showTipo: true},
  {id: 26, codigo: 'MAMONA', label: 'Mamona (sementes)', showTipo: true},
  {id: 36, codigo: 'MANDIOCA', label: 'Mandioca ou Aipim', showTipo: true},
  {id: 27, codigo: 'MELANCIA', label: 'Melancia', showTipo: true},
  {id: 28, codigo: 'MELAO', label: 'Melão', showTipo: true},
  {id: 29, codigo: 'MENTA', label: 'Menta', showTipo: true},
  {id: 30, codigo: 'MILHO', label: 'Milho (em grão)', showTipo: true},
  {id: 31, codigo: 'MORANGO', label: 'Morango', showTipo: true},
  {id: 32, codigo: 'SOJA', label: 'Soja (em grão)', showTipo: false},
  {id: 33, codigo: 'SORGO', label: 'Sorgo', showTipo: false},
  {id: 34, codigo: 'TOMATE', label: 'Tomate', showTipo: false},
  {id: 35, codigo: 'TRIGO', label: 'Trigo (em grão)', showTipo: false},
  {id: 37, codigo: 'OUTROS', label: 'Outros', showTipo: true}
]



// WEBPACK FOOTER //
// ./src/utils/tipoCulturasTemporarias.js